import React, { useMemo } from 'react';

const AVATAR_COLORS = ['#3E4954', '#4285f4', '#059669', '#d97706', '#e1306c'];

const BeraterMetrics = ({ bookings }) => {
  const beraterStats = useMemo(() => {
    const map = {};
    bookings?.forEach(b => {
      const name = b?.berater || 'Unbekannt';
      if (!map?.[name]) map[name] = { name, total: 0, onsite: 0, phone: 0, webinars: new Set(), sources: {} };
      map[name].total += 1;
      if (b?.type === 'onsite') map[name].onsite += 1;
      else map[name].phone += 1;
      if (b?.webinar_id) map?.[name]?.webinars?.add(b?.webinar_id);
      const src = b?.utm_source || 'direct';
      map[name].sources[src] = (map?.[name]?.sources?.[src] || 0) + 1;
    });
    const total = bookings?.length || 1;
    return Object.values(map)?.map(b => ({
        ...b,
        webinarCount: b?.webinars?.size,
        share: total > 0 ? Math.round((b?.total / total) * 100) : 0,
        topSource: Object.entries(b?.sources)?.sort((a, z) => z?.[1] - a?.[1])?.[0]?.[0] || 'direct',
      }))?.sort((a, b) => b?.total - a?.total);
  }, [bookings]);

  const totalBookings = bookings?.length || 0;

  return (
    <div style={{ background: 'white', borderRadius: '20px', border: '1px solid #dde1e7', boxShadow: '0 4px 6px rgba(62,73,84,0.04), 0 10px 20px rgba(62,73,84,0.06)', overflow: 'hidden', marginBottom: '24px' }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #dde1e7', background: '#3E4954', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
          <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/>
            <circle cx='9' cy='7' r='4'/>
            <path d='M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75'/>
          </svg>
        </div>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '16px', fontWeight: 700, color: 'white', margin: 0 }}>Berater-Performance</h2>
          <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', fontFamily: 'var(--font-ui)', margin: 0 }}>Buchungen und Kanalverteilung je Berater</p>
        </div>
      </div>
      <div style={{ padding: '24px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '16px' }}>
        {beraterStats?.length === 0 ? (
          <div style={{ padding: '48px 24px', textAlign: 'center', color: '#6b7a8d', fontSize: '14px', gridColumn: '1/-1' }}>Keine Daten verfuegbar.</div>
        ) : (
          beraterStats?.map((b, idx) => (
            <div key={b?.name} style={{ border: '1px solid #dde1e7', borderRadius: '16px', padding: '20px', background: '#fafbfc', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: AVATAR_COLORS?.[idx % AVATAR_COLORS?.length] }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{
                  width: '44px', height: '44px', borderRadius: '50%',
                  background: AVATAR_COLORS?.[idx % AVATAR_COLORS?.length],
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'white', fontSize: '15px', fontWeight: 700, fontFamily: 'var(--font-ui)', flexShrink: 0,
                }}>
                  {b?.name?.split(' ')?.map(w => w?.[0])?.join('')?.slice(0, 2)?.toUpperCase()}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '15px', fontWeight: 700, color: '#1e2b38', fontFamily: 'var(--font-ui)' }}>{b?.name}</div>
                  <div style={{ fontSize: '12px', color: '#6b7a8d', fontFamily: 'var(--font-ui)' }}>{b?.total} Buchungen - {b?.share}% Anteil</div>
                </div>
                <div style={{ fontSize: '28px', fontWeight: 700, color: AVATAR_COLORS?.[idx % AVATAR_COLORS?.length], fontFamily: 'var(--font-heading)', lineHeight: 1 }}>{b?.total}</div>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ fontSize: '11px', fontWeight: 600, color: '#6b7a8d', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Anteil gesamt</span>
                  <span style={{ fontSize: '11px', fontWeight: 700, color: '#1e2b38', fontFamily: 'var(--font-ui)' }}>{b?.share}%</span>
                </div>
                <div style={{ height: '6px', background: '#e8eaed', borderRadius: '100px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: b?.share + '%', background: AVATAR_COLORS?.[idx % AVATAR_COLORS?.length], borderRadius: '100px', transition: 'width 600ms ease' }} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '14px' }}>
                <div style={{ background: 'white', borderRadius: '10px', padding: '10px 12px', border: '1px solid #dde1e7' }}>
                  <div style={{ fontSize: '18px', fontWeight: 700, color: '#1e2b38', fontFamily: 'var(--font-heading)', lineHeight: 1 }}>{b?.onsite}</div>
                  <div style={{ fontSize: '11px', color: '#6b7a8d', fontFamily: 'var(--font-ui)', marginTop: '2px' }}>Vor-Ort</div>
                </div>
                <div style={{ background: 'white', borderRadius: '10px', padding: '10px 12px', border: '1px solid #dde1e7' }}>
                  <div style={{ fontSize: '18px', fontWeight: 700, color: '#1e2b38', fontFamily: 'var(--font-heading)', lineHeight: 1 }}>{b?.phone}</div>
                  <div style={{ fontSize: '11px', color: '#6b7a8d', fontFamily: 'var(--font-ui)', marginTop: '2px' }}>Telefon</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '12px', color: '#6b7a8d', fontFamily: 'var(--font-ui)' }}>Top-Kanal</span>
                <span style={{ fontSize: '12px', fontWeight: 700, color: '#3E4954', fontFamily: 'var(--font-ui)', background: 'rgba(62,73,84,0.08)', padding: '2px 10px', borderRadius: '100px' }}>{b?.topSource}</span>
              </div>
            </div>
          ))
        )}
      </div>
      <div style={{ padding: '14px 24px', borderTop: '1px solid #dde1e7', background: '#f5f6f8', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
        <span style={{ fontSize: '12px', color: '#6b7a8d', fontFamily: 'var(--font-ui)' }}>{beraterStats?.length} aktive Berater - {totalBookings} Buchungen gesamt</span>
        <span style={{ fontSize: '12px', color: '#6b7a8d', fontFamily: 'var(--font-ui)' }}>Durchschnitt {beraterStats?.length > 0 ? Math.round(totalBookings / beraterStats?.length) : 0} Buchungen/Berater</span>
      </div>
    </div>
  );
};

export default BeraterMetrics;
